import { useDesignContext } from '@klarna/designtokens';
import { defaultComponentTokens } from './defaultComponentTokens';
export var getDefaultStyleSheet = _ref => {
  var {
    colorToken = 'icon/color',
    colorTokenArgs
  } = _ref;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var designContext = useDesignContext(defaultComponentTokens);
  return {
    pathStyle: {
      fill: designContext.get(colorToken, colorTokenArgs).toRGBA(),
      style: {
        transition: 'fill .2s ease'
      }
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map